/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientInsuranceViewModel } from './PatientInsuranceViewModel'; 

export function getPatientInsuranceOptions(stayId: string, onSuccess?: (result: PatientInsuranceViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-insurance', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/billing/insurance/queries/getpatientinsurance/' + stayId;
			const resp = await axios.get<PatientInsuranceViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}